<ng-template #bestRateCondition let-desc>
  <span class="accordion-list-item">
    <span class="accordion-list-item-bullet"></span>
    {{ desc }}
  </span>
</ng-template>

<div class="step-holder">
  <div>
    <span [innerHTML]="'fulFillConditionsDescription' | i18n" class="step-description"></span>
    <div *ngIf="rateInUse" class="section-gap">
      <span class="section-header">{{ "fulFillTheseConditions" | i18n }}</span>
      <app-accordion
        collapseIcon="minimize"
        expandIcon="maximize"
        customClass="tw-bg-dt-surface-elevated"
        [defaultCollapsed]="false"
        [contentTemplate]="fulFillConditions"
      >
        <app-best-account-tooltip title [lastViewDate]="rateInUse.last_updated" class="tw-w-full">
          <app-best-scenario-dialog-title [isPrimary]="false">
            {{ "highestInterestBankAccount" | i18n }}
          </app-best-scenario-dialog-title>

          <app-best-scenario-dialog-title class="tw-text-left tw-text-base">
            {{ bestAccountInfo.accountName }}
          </app-best-scenario-dialog-title>
        </app-best-account-tooltip>
      </app-accordion>

      <ng-template #fulFillConditions>
        <!-- Neither condition is valid: no list, rather than an empty box. -->
        <div
          *ngIf="isValidIntrinsicDesc || isValidActionDesc"
          class="accounts-container tw-m-3 tw-rounded-lg tw-bg-tealgray-50 tw-p-3"
        >
          <ng-container *ngIf="isValidIntrinsicDesc">
            <ng-container
              *ngTemplateOutlet="
                bestRateCondition;
                context: { $implicit: rateInUse.condition_intrinsic_desc }
              "
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="isValidActionDesc">
            <ng-container
              *ngTemplateOutlet="
                bestRateCondition;
                context: { $implicit: rateInUse.condition_action_desc }
              "
            ></ng-container>
          </ng-container>
        </div>
      </ng-template>
    </div>

    <div *ngIf="earningsCard" class="section-gap">
      <best-scenario-stepper-earnings-card
        [earningsData]="earningsCard"
      ></best-scenario-stepper-earnings-card>
    </div>
  </div>
  <div class="secondary-buttons-holder tw-mt-2">
    <app-gloss-button class="tw-w-full" [options]="viewOtherAccounts"></app-gloss-button>
  </div>
</div>
